module.exports = __webpack_public_path__ + "assets/2-contact-rainmakers-to-find-tech-sales-jobs.03d90d1a.png";